import * as angular from 'angular';
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import UserServiceName, {UserService} from "../../services/users/user.service";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import template from './changePassword.tpl.html';

let requires = [LoaderServiceName, NotifyServiceName, UserServiceName];

export function openAdminChangePassword(user: apsViewModels.UserListItem,
                                        $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'AdminChangePasswordCtrl as changePasswordCtrl',
    resolve: {
      user: function() {
        return user;
      }
    }
  }).result;
}

export default angular.module('aps.controller.adminChangePassword', requires)
  .controller('AdminChangePasswordCtrl', adminChangePasswordCtrl)
  .name;

function adminChangePasswordCtrl(
  $modalInstance: mm.foundation.modalInstance,
  loaderService: LoaderService,
  notifyService: NotifyService,
  userService: UserService,
  user: apsViewModels.UserListItem
) {
  let vm = this;
  vm.user = {
    id: user.id
  };
  vm.userName = user.userName;

  vm.change = () => {
    if (vm.form.$invalid) {
      return;
    }

    loaderService.loadingPromise(
      userService.changePassword(vm.user)
        .then(function() {
          $modalInstance.close();
          notifyService.success('Password changed for ' + user.userName);
        }, notifyService.handleApiErrors));
  };

  vm.close = () => {
    $modalInstance.close();
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/users/changePassword.controller.ts